import React from "react";
import { COLORS } from "./tokens";

/**
 * RONA WALK concept logo.
 * Wordmark "WALK" where the letter L becomes a walking woman figure.
 * Tagline below. Tiny heart below tagline.
 */
const RonaWalkLogo = React.forwardRef(function RonaWalkLogo(
  { size = 360, color = COLORS.gold, showTagline = true, id = "rona-walk-logo" },
  ref
) {
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 420"
      width={size}
      height={(size * 420) / 800}
      role="img"
      aria-label="The Rona Walk — Where Movement Meets Peace"
    >
      <defs>
        <linearGradient id="rw-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={COLORS.goldLight} />
          <stop offset="100%" stopColor={COLORS.gold} />
        </linearGradient>
      </defs>

      {/* Small top label — "the" */}
      <text
        x="400"
        y="58"
        textAnchor="middle"
        fontFamily="'Marcellus', serif"
        fontSize="22"
        letterSpacing="8"
        fill={color}
        opacity="0.75"
      >
        THE RONA
      </text>

      {/* Word WALK — hand-placed letters, serif with soft flourishes */}
      <g fill={color} fontFamily="'Cormorant Garamond', serif" fontWeight="500">
        <text x="150" y="210" fontSize="170" letterSpacing="6">W</text>
        <text x="310" y="210" fontSize="170" letterSpacing="6">A</text>
        {/* Skip L — replaced by the woman figure */}
        <text x="560" y="210" fontSize="170" letterSpacing="6">K</text>
      </g>

      {/* Walking woman figure acting as the letter "L" */}
      {/* L vertical stem = the body + flowing hair line */}
      {/* L horizontal base = the forward-stepping leg/ground */}
      <g stroke="url(#rw-gold)" fill="url(#rw-gold)">
        {/* Head */}
        <circle cx="470" cy="80" r="14" />
        {/* Hair flowing back */}
        <path
          d="M462 72 C 448 68, 438 76, 434 88 C 432 96, 438 102, 446 100"
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
        />
        {/* Body (acts as L's vertical stem) — gentle curve suggesting motion */}
        <path
          d="M470 96
             C 476 130, 472 160, 466 190
             C 460 218, 458 232, 468 250"
          fill="none"
          strokeWidth="7"
          strokeLinecap="round"
        />
        {/* Back arm */}
        <path
          d="M468 130 C 454 150, 448 168, 454 186"
          fill="none"
          strokeWidth="5"
          strokeLinecap="round"
        />
        {/* Forward arm */}
        <path
          d="M474 132 C 488 148, 494 162, 492 180"
          fill="none"
          strokeWidth="5"
          strokeLinecap="round"
        />
        {/* Back leg (bent) */}
        <path
          d="M466 250 C 454 270, 446 286, 448 308"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
        />
        {/* Forward leg (extended — acts as L's horizontal base) */}
        <path
          d="M470 248
             C 482 260, 500 268, 526 270
             C 550 272, 570 270, 590 268"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
        />
      </g>

      {/* Tagline */}
      {showTagline && (
        <>
          <text
            x="400"
            y="310"
            textAnchor="middle"
            fontFamily="'Marcellus', serif"
            fontSize="26"
            letterSpacing="10"
            fill={color}
          >
            WHERE MOVEMENT MEETS PEACE
          </text>
          {/* decorative rule */}
          <line
            x1="310"
            y1="332"
            x2="490"
            y2="332"
            stroke={color}
            strokeOpacity="0.35"
            strokeWidth="0.8"
          />
          {/* tiny heart below tagline */}
          <path
            d="M400 360
               C 394 352, 382 352, 382 362
               C 382 370, 392 378, 400 384
               C 408 378, 418 370, 418 362
               C 418 352, 406 352, 400 360 Z"
            fill={color}
            opacity="0.85"
          />
        </>
      )}
    </svg>
  );
});

export default RonaWalkLogo;
